import { HttpApi } from "@effect/platform";
import { AttachmentGroup } from "./attachment";
import { ConversationGroup } from "./conversation";
import { HealthGroup } from "./health";
import { IntegrationGroup } from "./integration";
import { MeGroup } from "./me";
import { StreamGroup } from "./stream";
import { TagGroup } from "./tag";
import { TeamNotificationGroup } from "./team-notification";
import { WebhookGroup } from "./webhook";

export class Api extends HttpApi.make("effect-api")
  .add(HealthGroup)
  .add(MeGroup)
  .add(ConversationGroup)
  .add(IntegrationGroup)
  .add(WebhookGroup)
  .add(AttachmentGroup)
  .add(TeamNotificationGroup)
  .add(StreamGroup)
  .add(TagGroup) {}
